interface IconNewsProps {
  className?: string
}
export const IconHot = ({ className = '' }: IconNewsProps) => {
  return (
    <svg
      className={className}
      width='17'
      height='16'
      viewBox='0 0 17 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_8_5057)'>
        <path
          d='M15.2398 3.35438C14.9962 3.25924 14.7279 3.23424 14.4691 3.28254C14.2103 3.33085 13.9727 3.45028 13.7865 3.62563L12.0625 5.24188L9.00517 2.37563C8.75513 2.14129 8.41605 2.00964 8.0625 2.00964C7.70895 2.00964 7.36987 2.14129 7.11983 2.37563L4.0625 5.24188L2.3385 3.62563C2.15203 3.45086 1.91448 3.33186 1.65588 3.28365C1.39727 3.23544 1.12923 3.26019 0.885627 3.35478C0.642028 3.44937 0.43381 3.60954 0.287298 3.81505C0.140785 4.02057 0.0625563 4.26219 0.0625 4.50938L0.0625 11.1256C0.0635586 11.9541 0.415088 12.7484 1.03998 13.3342C1.66487 13.9201 2.5121 14.2496 3.39583 14.2506H12.7292C13.6129 14.2496 14.4601 13.9201 15.085 13.3342C15.7099 12.7484 16.0614 11.9541 16.0625 11.1256V4.50938C16.0626 4.26217 15.9844 4.02049 15.838 3.81491C15.6916 3.60932 15.4834 3.44906 15.2398 3.35438Z'
          fill='#00C1D5'
        />
      </g>
      <defs>
        <clipPath id='clip0_8_5057'>
          <rect
            width='16'
            height='15'
            fill='white'
            transform='translate(0.0625 0.50061)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
